/**
 * Fisher–Yates (Knuth) shuffle. Returns a new array; the input is not mutated.
 *
 * Prefer this over `array.sort(() => Math.random() - 0.5)`: that idiom relies on
 * a comparator that violates transitivity (if `a < b` and `b < c`, it does not
 * guarantee `a < c`), so engine sort implementations produce a biased, non-uniform
 * distribution. Fisher–Yates produces a uniform, unbiased permutation.
 *
 * @param array  Items to shuffle.
 * @param random RNG returning a float in [0, 1); injectable to make shuffles
 *               deterministic in tests.
 */
export function shuffle<T>(
  array: readonly T[],
  random: () => number = Math.random,
): T[] {
  const result = array.slice();
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}
